import {z} from 'zod';

export const ProfileSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  phoneNumber: z
    .string()
    .min(1, 'Phone number is required')
    .regex(/^\+250\d{9}$/, 'Phone number of this format +250 7XX XXX XXX'),
  profilePicture: z
    .union([z.instanceof(File), z.string()])
    .nullable()
    .optional(),
});
